<template>
    <div>
        <div class="checkbox_div mr_10">
            <!-- eslint-disable -->
            <input
                type="checkbox"
                required="required"
                class="mr_6"
                v-model="value"
                v-on:change="setValue"
            />
            <!-- eslint-enable -->
            <span for="html">Shadow</span>
        </div>
    </div>
</template>

<script>
export default {
    /* eslint-disable */
    name: "Emboss",
    /* eslint-enable */
    props: ["value"],
    data: () => {
        return {};
    },
    methods: {
        setValue(e) {
            this.$emit("set-value", this.value);
            console.log(e);
        }
    }
};
</script>

<style></style>
